module.exports = __webpack_public_path__ + "img/0xa9603a59e21d29e37ac39cf1b5f5abf5006b22a3.a05b57cc.png";